<template>
  <transition mode="out-in" name="slide-fade" appear>
    <footer
      :class="{
        'dividend-page':
          !this.$store.getters.isLoading &&
          this.$store.getters.dataLoaded &&
          this.$store.getters.loadData.Status === 200,
        '':
          !this.$store.getters.isLoading ||
          (!this.$store.getters.isLoading &&
            !this.$store.getters.isError &&
            !this.$store.getters.dataLoaded) ||
          (this.$store.getters.checkIsDev &&
            !this.$store.getters.alertIsOpen) ||
          this.$store.getters.alertIsOpen,
      }"
    >
      <div class="px-3 px-lg-4 py-2">
        <div class="row">
          <div
            class="d-none d-lg-block col-12 col-lg-4 col-xl-2 order-1 order-lg-3"
          >
            <a
              style="text-decoration: none"
              href="https://www.buymeacoffee.com/savajava/membership"
              target="_blank"
            >
              <button class="btn donate-btn w-100 mb-3">
                <img src="coffee-cup.png" alt="buy me coffee" />
                <strong> Buy me a coffee </strong>
              </button>
              <a
                class="p-0 btn open-ai w-100 mb-3"
                href="https://openfuture.ai/tool/savajava"
                target="_blank"
                ><img
                  v-if="!this.$store.state.isLight"
                  src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=neutral"
                  loading="lazy"
                  alt="SavaJava"
                  class="color-button neutral-button active w-100" /><img
                  v-else
                  src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=dark"
                  loading="lazy"
                  alt="SavaJava"
                  class="color-button neutral-button active w-100"
              /></a>
            </a>
          </div>
          <div class="col-lg-5 col-xl-7 order-2"></div>
          <div
            class="col-12 col-lg-3 text-center text-lg-start order-3 order-lg-1"
          >
            <p class="my-2">
              <span
                v-if="isBrowserCompatibility().includes('Safari')"
                class="highlight d-inline-block mb-2"
              >
                {{ "Use Chrome or Firefox for better experience!" }}
              </span>
              <br />
              {{ updateDate() }} &copy; SavaJava<sup><sup>TM</sup></sup>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      isMobile: null,
    };
  },
  mounted() {
    // logic to activate this function whenever screen is resized
    window.addEventListener("resize", this.checkIsMobile);
    this.updateDate();
  },
  created() {
    // logic to activate this function whenever screen is resized
    window.addEventListener("resize", this.checkIsMobile);
  },
  unmounted() {
    // logic to deactivate this function whenever screen is resized
    window.removeEventListener("resize", this.checkIsMobile);
  },
  computed: {
    dataLoaded() {
      return this.$store.getters.dataLoaded;
    },
    isDev() {
      return this.$store.getters.checkIsDev;
    },
    checkDisclaimerIsOpen() {
      return this.$store.getters.disclaimerIsOpen;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    isHomePage() {
      return this.$store.getters.isHomePage;
    },
    alertIsOpen() {
      return this.$store.getters.alertIsOpen;
    },
  },
  methods: {
    checkIsMobile() {
      console.log(window.innerWidth);
      if (window.innerWidth < 992) {
        return (this.isMobile = true);
      }
      return (this.isMobile = false);
    },
    updateDate() {
      return new Date().getFullYear();
    },
    isBrowserCompatibility() {
      return navigator.userAgentData.brands[0].brand.replace(
        "Not A;Brand",
        "Opera"
      );
    },
  },
};
</script>
<style scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}

.smart-button-container {
  height: 100vh;
}

footer.dividend-page {
  position: static;
}

span.highlight {
  color: rgb(5, 190, 5);
}

.light .form-validation-alert {
  color: #333;
}

.light span.highlight {
  color: rgb(5, 120, 5);
}
</style>
